import React, { useState, useEffect } from 'react';
import Layout from '../../Layout';
import Sidebar from './Sidebar';
import ProfileSection from './ProfileSection';
import BookingsSection from './BookingsSection';
import SecuritySettings from './SecuritySettings';
import { getCurrentUserData } from '../../../helpers/user';
import UserWorkshopsComponent from '../UserWorkshopsComponent';

const AccountPage = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await getCurrentUserData();
      // console.log(response);
      setUserData(response);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'profile':
        return <ProfileSection userData={userData} onUpdate={fetchUserData} />;
      case 'bookings':
        return <BookingsSection userData={userData} />;
        case 'workshops':
          return <UserWorkshopsComponent userData={userData} onUpdate={fetchUserData} />;
      case 'settings':
        return <SecuritySettings userData={userData} onUpdate={fetchUserData} />;
      default:
        return <ProfileSection userData={userData} onUpdate={fetchUserData} />;
    }
  };

  return (
    <Layout>
      <div className="container my-5">
        <div className="row">
          <div className="col-md-3 mb-4">
            <Sidebar 
              userData={userData}
              activeTab={activeTab}
              onTabChange={setActiveTab}
            />
          </div>
          <div className="col-md-9">
            {renderContent()}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AccountPage;